import { Modal } from "tailwindcss-stimulus-components"

// Version diff modal (card #2079 Phase 2) — mirrors
// mission_task_results_modal_controller.js exactly: a named Modal subclass,
// dialog/frame targets, reset-frame-then-set-src-from-the-clicked-row's-data-
// attribute, Escape handling. Each row in the versions summary list carries
// data-deck-version-modal-version-id-value; #open reads it off the element
// that was actually clicked and loads DecksController#version into the frame.
export default class DeckVersionModal extends Modal {
  static targets = ["dialog", "frame"]
  static values = { deckId: Number }

  connect() {
    super.connect()
    this.handleEscapeBound = (event) => {
      if (event.key === "Escape") {
        event.preventDefault()
        this.close(event)
      }
    }
    if (this.hasDialogTarget) {
      this.dialogTarget.addEventListener("keydown", this.handleEscapeBound)
    }
  }

  disconnect() {
    if (this.hasDialogTarget) {
      this.dialogTarget.removeEventListener("keydown", this.handleEscapeBound)
    }
    super.disconnect()
  }

  open(event) {
    const versionId = this.getVersionIdFromEvent(event)

    if (this.hasFrameTarget) {
      this.resetFrame()
    }

    super.open(event)

    if (versionId) {
      this.loadContent(versionId)
    }

    if (this.hasDialogTarget) {
      this.dialogTarget.focus()
    }
  }

  getVersionIdFromEvent(event) {
    if (!event?.target) return null
    const row = event.target.closest("[data-deck-version-modal-version-id-value]")
    return row ? row.dataset.deckVersionModalVersionIdValue : null
  }

  close(event) {
    event?.preventDefault()
    super.close(event)
  }

  resetFrame() {
    this.frameTarget.removeAttribute("src")
    this.frameTarget.removeAttribute("complete")
    this.frameTarget.removeAttribute("loading")
    this.frameTarget.innerHTML = this.loadingSpinnerHTML()
  }

  loadingSpinnerHTML() {
    return `<div class="p-8 flex items-center justify-center">
      <div class="flex flex-col items-center">
        <svg class="animate-spin h-8 w-8 text-blue-600 mb-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <p class="text-sm text-gray-500">Loading version...</p>
      </div>
    </div>`
  }

  loadContent(versionId) {
    if (this.hasFrameTarget && this.hasDeckIdValue && versionId) {
      const url = `/decks/${this.deckIdValue}/versions/${versionId}`
      this.frameTarget.setAttribute("src", url)
    }
  }
}
